import mutations from './patientHistory.mutations'
import actions from './patientHistory.actions'
import getters from './patientHistory.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
